var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-time-picker" }, [
    _vm.$slots.default
      ? _c(
          "div",
          { staticClass: "app-time-picker__label" },
          [
            _vm.required
              ? _c("span", { staticClass: "require-mark" }, [_vm._v("*")])
              : _vm._e(),
            _vm._v(" "),
            _vm._t("default")
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "app-time-picker__input-wrapper",
        class: {
          "app-time-picker__input-wrapper--disabled": _vm.disabled,
          "app-time-picker__input-wrapper--error": _vm.hasError
        }
      },
      [
        _c("input", {
          staticClass: "app-time-picker__input--hidden",
          attrs: { required: _vm.required },
          domProps: { value: _vm.hasError ? "" : _vm.timeValue },
          on: { invalid: _vm.setInvalidMessage }
        }),
        _vm._v(" "),
        _c("AppIcon", {
          staticClass: "app-time-picker__icon",
          attrs: { "icon-name": "clock", "icon-color": "#778395" }
        }),
        _vm._v(" "),
        _c("input", {
          staticClass: "app-time-picker__input",
          attrs: {
            type: "number",
            maxlength: "2",
            min: "0",
            max: "12",
            placeholder: "HH",
            disabled: _vm.disabled,
            required: _vm.required
          },
          domProps: { value: _vm.hours },
          on: {
            keypress: function($event) {
              return _vm.keyPressHandler($event)
            },
            keydown: function($event) {
              _vm.hours = _vm.keyDownHandler($event)
            },
            blur: function($event) {
              _vm.hours = _vm.padStart(_vm.hours)
            },
            input: function($event) {
              _vm.hours = _vm.inputHandler($event)
            },
            paste: function($event) {
              $event.preventDefault()
            },
            invalid: _vm.setInvalidMessage
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "app-time-picker__ticks" }, [
          _c("span", {
            staticClass: "arrow arrow--up",
            on: {
              click: function($event) {
                return _vm.updateHours(1)
              }
            }
          }),
          _vm._v(" "),
          _c("span", {
            staticClass: "arrow arrow--down",
            on: {
              click: function($event) {
                return _vm.updateHours(-1)
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "app-time-picker__divider" }, [_vm._v(":")]),
        _vm._v(" "),
        _c("input", {
          staticClass: "app-time-picker__input",
          attrs: {
            type: "number",
            maxlength: "2",
            min: "0",
            max: "59",
            placeholder: "MM",
            disabled: _vm.disabled
          },
          domProps: { value: _vm.minutes },
          on: {
            keypress: function($event) {
              return _vm.keyPressHandler($event)
            },
            keydown: function($event) {
              _vm.minutes = _vm.keyDownHandler($event)
            },
            blur: function($event) {
              _vm.minutes = _vm.padStart(_vm.minutes)
            },
            input: function($event) {
              _vm.minutes = _vm.inputHandler($event)
            },
            paste: function($event) {
              $event.preventDefault()
            },
            invalid: _vm.setInvalidMessage
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "app-time-picker__ticks" }, [
          _c("span", {
            staticClass: "arrow arrow--up",
            on: {
              click: function($event) {
                return _vm.updateMinutes(1)
              }
            }
          }),
          _vm._v(" "),
          _c("span", {
            staticClass: "arrow arrow--down",
            on: {
              click: function($event) {
                return _vm.updateMinutes(-1)
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "app-time-picker__toggle" }, [
          _c("label", { staticClass: "app-time-picker__period-wrapper" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.period,
                  expression: "period"
                }
              ],
              attrs: { type: "radio", value: "AM", disabled: _vm.disabled },
              domProps: { checked: _vm._q(_vm.period, "AM") },
              on: {
                change: function($event) {
                  _vm.period = "AM"
                }
              }
            }),
            _vm._v(" "),
            _c("span", { staticClass: "app-time-picker__period" }, [
              _vm._v("\n\t\t\t\t\tAM\n\t\t\t\t")
            ])
          ]),
          _vm._v(" "),
          _c("label", { staticClass: "app-time-picker__period-wrapper" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.period,
                  expression: "period"
                }
              ],
              attrs: { type: "radio", value: "PM" },
              domProps: { checked: _vm._q(_vm.period, "PM") },
              on: {
                change: function($event) {
                  _vm.period = "PM"
                }
              }
            }),
            _vm._v(" "),
            _c("span", { staticClass: "app-time-picker__period" }, [
              _vm._v("\n\t\t\t\t\tPM\n\t\t\t\t")
            ])
          ])
        ])
      ],
      1
    ),
    _vm._v(" "),
    _vm.hasError
      ? _c("p", { staticClass: "app-time-picker__error" }, [
          _vm._v(
            "\n\t\t" +
              _vm._s(
                _vm.error || _vm.inputInvalidMessage || _vm.invalidMessage
              ) +
              "\n\t"
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c8c68bc2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c8c68bc2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app-components/AppTimePicker.vue
// module id = null
// module chunks = 